import React from 'react'
import Pt from 'prop-types'
import { Alert, Button, FormControl } from 'react-bootstrap'

import Icon from 'internal-components/src/components/Icon'
import FormField from 'internal-components/src/components/Form/FormField'

export default function RegisteredEmailField({
  authenticate,
  bsSize,
  controlLabel,
  emailChecking = false,
  emailRegistered = null,
  onChange,
  placeholder = controlLabel,
  renderRegistered = auth => (
    <Alert bsStyle="warning" style={{ marginTop: '0.5em' }}>
      <p>
        <Icon name="exclamation-triangle" /> This email address is already
        registered with us. To continue with this signup, please log in.
      </p>

      {typeof auth === 'function' && (
        <Button
          bsSize="sm"
          bsStyle="warning"
          onClick={() => auth()}
          style={{ marginTop: '0.5em' }}
        >
          <Icon name="user" /> Log in
        </Button>
      )}
    </Alert>
  ),
  value,
  ...fieldProps
}) {
  if (authenticate === false) {
    emailChecking = false
    emailRegistered = false
  }

  return (
    <FormField
      bsSize={bsSize}
      controlLabel={controlLabel}
      loading={emailChecking}
      validationState={emailRegistered ? 'warning' : undefined}
      value={value}
      {...fieldProps}
    >
      <FormControl
        onChange={onChange}
        placeholder={placeholder}
        type="text"
        value={value}
      />
      {emailRegistered && renderRegistered(authenticate)}
    </FormField>
  )
}

RegisteredEmailField.propTypes = {
  authenticate: Pt.oneOfType([Pt.func, Pt.bool]).isRequired,
  bsSize: Pt.string,
  controlLabel: Pt.string,
  emailChecking: Pt.bool,
  emailRegistered: Pt.bool,
  onChange: Pt.func.isRequired,
  placeholder: Pt.string,
  renderRegistered: Pt.func,
  // eslint-disable-next-line react/forbid-prop-types
  value: Pt.any,
}



// WEBPACK FOOTER //
// ./src/components/Form/RegisteredEmailField.jsx